import { render, staticRenderFns } from "./return-policy.vue?vue&type=template&id=3dded49d&scoped=true&"
import script from "./return-policy.vue?vue&type=script&lang=js&"
export * from "./return-policy.vue?vue&type=script&lang=js&"
import style0 from "./return-policy.vue?vue&type=style&index=0&id=3dded49d&lang=scss&scoped=true&"
import style1 from "./return-policy.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dded49d",
  null
  
)

export default component.exports
import {QLayout} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout})
